import { useCallback } from "react";
import { useSWRConfig } from "swr";
import { NotificationList } from "~/components/common/notifications/settings/NotificationList";
import type { NskResponse } from "~/models/Api";
import type { Notification, NotificationEdit } from "~/models/Notification";
import type { Status } from "~/models/Status";
import type { Subtype } from "~/models/Subtype";
import { destroy, update } from "~/utils/api/CompanyNotification";
import { generatePath } from "~/utils/generatePath";

type Props = {
	notifications: Notification[];
	statuses: Status[];
	subtypes: Subtype[];
};

export function NotificationSetting({
	statuses,
	subtypes,
	notifications
}: Props) {
	const { mutate: globalMutate } = useSWRConfig();
	const handleUpdate = useCallback(
		async (
			notification: NotificationEdit,
			notificationId: number
		): Promise<NskResponse> => update(notification, notificationId),
		[]
	);
	const handleDestroy = useCallback(
		async (notification: Notification): Promise<NskResponse> =>
			destroy(notification),
		[]
	);

	return (
		<NotificationList
			handleDestroy={handleDestroy}
			handleMutate={async () =>
				await globalMutate(generatePath("/company_notifications"))
			}
			handleUpdate={handleUpdate}
			notifications={notifications}
			statuses={statuses}
			subtypes={subtypes}
			type="CompanyNotification"
			useLineNotification={false}
		/>
	);
}
